import(/* webpackMode: "eager" */ "/vercel/path0/app/(static)/privacy/page.tsx");
